
import { getEcuadorServerDate } from "@/hooks/getEcuadorTime";
import { databases } from "@/lib/appwrite";
import { Query } from "appwrite";

export async function createWorkSession(
  userId: string,
  clockIn: Date,
  location: [number, number]
) {
  //Obtener rango del día actual en hora Ecuador
  const ecuadorDate = await getEcuadorServerDate();
  ecuadorDate.setHours(0, 0, 0, 0);
  const tomorrow = new Date(ecuadorDate);
  tomorrow.setDate(tomorrow.getDate() + 1);

  //  Consultar si ya hay sesión hoy para este usuario
  const existingSessions = await databases.listDocuments(
    import.meta.env.VITE_APPWRITE_DATABASE_ID,
    import.meta.env.VITE_WORK_SESSIONS_COLLECTION_ID,
    [
      Query.equal("userId", userId),
      Query.greaterThanEqual("clockIn", ecuadorDate.toISOString()),
      Query.lessThan("clockIn", tomorrow.toISOString()),
    ]
  );

  if (existingSessions.documents.length > 0) {
    throw new Error("Ya existe una sesión registrada para hoy.");
  }

  // Si no existe, crear la sesión
  const [lat, lng] = location;

  return await databases.createDocument(
    import.meta.env.VITE_APPWRITE_DATABASE_ID,
    import.meta.env.VITE_WORK_SESSIONS_COLLECTION_ID,
    "unique()",
    {
      userId,
      clockIn: clockIn.toISOString(),
      clockInLocation: [String(lat), String(lng)],
      status: "active",
      createdAt: clockIn.toISOString(),
      breaksTaken: 0,
      breakLimitReached: false,
    }
  );
}
